export default "__VITE_ASSET__DwKt7bKT__"